<template>
  <v-container fluid style="width: 80%">
    <v-data-table
      dense
      :headers="headers"
      :items="filteredCasefiles"
      class="elevation-1"
      :loading="loadTable"
      loading-text="Working on it ......"
      style="cursor: pointer"
      @click:row="viewItem"
      @update:options="onUpdateOptions"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      :page="page"
      :items-per-page.sync="pageSize"
      :server-items-length="total"
      :footer-props="{
        showFirstLastPage: true,
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
      
    >
      <template v-slot:[`header.id`]="{ header }">
        {{ header.text.toUpperCase() }}
      </template>
      <!-- <template slot="item.numbering" slot-scope="props">
        {{ props.index + 1 }}
      </template> -->

      <template v-slot:[`item.id`]="{ item }">
        <tr class="font-weight-black d-flex">
          AA/
          <div v-for="dept in filterDept(item.refType)" :key="dept.id">
            {{ dept.name
            }}<span
              v-for="(subDept, index) in filterSubDept(item.subRefType)"
              :key="index"
              >/{{ subDept.subCode }}</span
            >
          </div>
          /{{
            item.id
          }}/{{
            yearOnly(item.createdAt)
          }}/
          <div
            v-for="(branch, index) in filterBranch(item.branch)"
            :key="index"
          >
            {{ branch.brCode }}
          </div>
        </tr>
      </template>

      <template slot="item.numbering" slot-scope="props">
        {{ props.index + 1 }}
      </template>
      <template v-slot:[`item.vehicleNo`]="{ item }">
        <span v-if="item.vehicleNo">
          <div v-if="item.vehicleNo">
            {{ item.vehicleNo.toUpperCase() }}
          </div>
        </span>
        <span v-else>TBA</span>
      </template>
      <template v-slot:[`item.dateOfAssign`]="{ item }">
        {{ formatDate(item.dateOfAssign) }}
      </template>
      <template v-slot:[`item.days`]="{ item }">
        {{ dateDiff(moment(item.dateOfAssign).format(), moment().format()) }}
        Day(s)
      </template>
      <template v-slot:[`item.adjuster`]="{ item }">
        <span v-if="item.adjuster">
          <div v-for="adjuster in filterUser(item.adjuster)" :key="adjuster.id">
            {{ adjuster.username }}
          </div>
        </span>
        <span v-else>TBA</span>
      </template>
      <template v-slot:[`item.fileStatus`]="{ item }">
        <v-tooltip left transition="fab-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="item.flag === 1"
              small
              color="green lighten-1"
              v-bind="attrs"
              v-on="on"
            >
              <!-- mdi-check-decagram-outline -->
              mdi-shield-check
            </v-icon>
            <v-icon
              v-if="item.flag === 2"
              small
              color="orange lighten-1"
              v-bind="attrs"
              v-on="on"
            >
              <!-- mdi-alarm-light-off-outline -->
              mdi-shield-half-full
            </v-icon>
            <v-icon
              v-if="item.flag === 3"
              small
              color="red darken-5"
              v-bind="attrs"
              v-on="on"
            >
              <!-- mdi-alarm-light-off-outline -->
              mdi-shield-alert-outline
            </v-icon>
          </template>
          <!-- <span> {{ item.flag ? "Genuine" : "Suspected Fraud" }}</span> -->
          <span v-if="item.flag === 1">GENUINE</span>
          <span v-if="item.flag === 2">SUSPECTED FRAUD</span>
          <span v-if="item.flag === 3">FRAUD</span>
        </v-tooltip>

        <span
          v-for="allStatus in filterStages(item.fileStatus)"
          :key="allStatus.id"
          v-bind="allStatus.item"
        >
          <v-chip label outlined block x-small>
            {{ allStatus.name }}
          </v-chip>
        </span>
      </template>

      <!-- <template v-slot:[`item.fileStatus`]="{ item }">
        <span
          v-for="allStatus in filterStages(item.fileStatus)"
          :key="allStatus.id"
        >
          {{ allStatus.name }}
        </span>
      </template> -->

      <template v-slot:[`item.insurer`]="{ item }">
        <div v-for="ins in filterIns(item.insurer)" :key="ins.id">
          <div class="text-truncate" style="max-width: 80px">
            {{ ins.name }}
          </div>
        </div>
      </template>
      <template v-slot:[`item.dateOfLoss`]="{ item }">
        {{ formatDate(item.dateOfLoss) }}
      </template>
      <template v-slot:[`item.placeOfLoss`]="{ item }">
        <!-- {{ formatDate(item.dateOfLoss) }} -->
        {{ item.placeOfLoss }},
        <span v-for="state in filterStates(item.stateOfLoss)" :key="state.id"
          >{{ state.name }}
        </span>
      </template>

      <!-- <template v-slot:[`item.id`]="{ item }">
        <tr
          class="font-weight-black"
          style="cursor: pointer"
          @click="viewItem(item.id)"
        >
          AA/{{
            item.refType
          }}/{{
            item.id
          }}/{{
            item.year
          }}/{{
            item.branch
          }}
        </tr>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import BranchDataService from "../../services/BranchDataService";
import StateDataService from "../../services/StateDataService";
import DeptDataService from "../../services/DeptDataService";
import SubRefTypeDataService from "../../services/SubDeptDataService";
import InsDataService from "../../services/InsDataService";
import StagesDataService from "../../services/StageDataService";
import MemberDataService from "../../services/MemberDataService";
import moment from "moment";

export default {
  name: "detail-by-branch",
  components: {},

    data() {
      return {
        loadTable: true,
        page: 1,
        pageSize: 50,
      headers: [
        // {
        //   text: "File Reference",
        //   align: "start",
        //   value: "id",
        // },
        // { text: "Status", value: "fileStatus" },
        // { text: "Insurer", value: "insurer" },
        // { text: "Insurers Reference", value: "claimNo" },
        // { text: "Date Of Loss", value: "dateOfLoss" },
        // { text: "Place Of Loss", value: "placeOfLoss" },
        {
          text: "NO.",
          align: "start",
          sortable: false,
          value: "numbering",
        },
        {
          text: "VEHICLE NO.",
          align: "center",
          value: "vehicleNo",
          sortable: false,
        },
        {
          text: "AA REF",
          align: "start",
          value: "id",
          sortable: false,
        },

        {
          text: "INSURER",
          align: "start",
          value: "insurer",
          sortable: false,
        },
        {
          text: "DOA",
          align: "start",
          sortable: false,
          value: "dateOfAssign",
        },
        {
          text: "DAYS",
          align: "start",
          sortable: false,
          value: "days",
        },
        {
          text: "ADJUSTER",
          align: "start",
          sortable: false,
          value: "adjuster",
        },
        {
          text: "STATUS",
          align: "center",
          value: "fileStatus",
          sortable: false,
        },
      ],
      casefiles: [],
      departments: [],
      subRefTypes: [],
      branches: [],
      states: [],
      insurer: [],
      members: [],
      stages: [],
      total: 0,
    };
  },
      mounted() {
    this.retrieveCasefiles(this.page, this.pageSize);
    this.retrieveDepts();
    this.retrieveSubRefType();
    this.retrieveBranches();
    this.retrieveStates();
    this.retrieveIns();
    this.retrieveMembers();
    this.retrieveStages();
  },

  computed: {
    filteredCasefiles() {
      const user = this.$store.state.auth.user || {};
      const roles = Array.isArray(user.roles) ? user.roles : [];
      const fileStatusParam = this.$route.params.fileStatus;
      const branchParam = this.$route.params.branch;

      // ADMIN / MANAGER: full access (within this branch/status view)
      if (roles.includes("MANAGER") || roles.includes("ADMIN")) {
        return this.casefiles.filter(
          (casefile) =>
            casefile.fileStatus === fileStatusParam &&
            casefile.branch == branchParam
        );
      }

      // BRANCH-level users: restrict by branch only (no department required)
      if (roles.includes("BRANCHCLERK") || roles.includes("BRANCHMANAGER")) {
        const userBranches = Array.isArray(user.branches)
          ? user.branches
          : user.branches
          ? [user.branches]
          : [];
        if (userBranches.length === 0) {
          return [];
        }
        return this.casefiles.filter(
          (x) =>
            userBranches.some((b) => b === x.branch) &&
            x.fileStatus === fileStatusParam &&
            x.branch == branchParam
        );
      }

      // ADJUSTER: filter by adjuster id, allow missing dept/branches arrays to be non-blocking
      if (roles.includes("ADJUSTER")) {
        const userDepts = Array.isArray(user.dept) ? user.dept : [];
        const userBranches = Array.isArray(user.branches) ? user.branches : [];
        return this.casefiles.filter(
          (x) =>
            (userDepts.length === 0 || userDepts.includes(x.refType)) &&
            (userBranches.length === 0 || userBranches.includes(x.branch)) &&
            String(x.adjuster) === String(user.id) &&
            x.fileStatus === fileStatusParam &&
            x.branch == branchParam
        );
      }

      // EDITOR: filter by editor id, allow missing dept/branches arrays to be non-blocking
      if (roles.includes("EDITOR")) {
        const userDepts = Array.isArray(user.dept) ? user.dept : [];
        const userBranches = Array.isArray(user.branches) ? user.branches : [];
        return this.casefiles.filter(
          (x) =>
            (userDepts.length === 0 || userDepts.includes(x.refType)) &&
            (userBranches.length === 0 || userBranches.includes(x.branch)) &&
            String(x.editor) === String(user.id) &&
            x.fileStatus === fileStatusParam &&
            x.branch == branchParam
        );
      }

      // Fallback: show files for the requested branch/status
      return this.casefiles.filter(
        (casefile) =>
          casefile.fileStatus === fileStatusParam &&
          casefile.branch == branchParam
      );
    },
  },

  methods: {
    moment: function (date) {
      return moment(date);
    },
    filterBranch(item) {
      return this.branches.filter((branch) => branch.id === item);
    },
    filterStates(item) {
      return this.states.filter((state) => state.id === item);
    },
    filterDept(item) {
      return this.departments.filter((dept) => dept.id === item);
    },
    filterSubDept(item) {
      return this.subRefTypes.filter((subRef) => subRef.id === item);
    },
    filterIns(item) {
      return this.insurer.filter((insurer) => insurer.id === item);
    },
    filterUser(item) {
      return this.members.filter((member) => member.id === item);
    },
    filterStages(item) {
      return this.stages.filter((stage) => stage.stageCode === item);
    },
    yearOnly(value) {
      // return moment(value).format("YYYY");
      return moment(value).format("YY");
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    dateDiff(startDateString, endDateString) {
      let start = moment(startDateString);
      let end = moment(endDateString);
      let duration = moment.duration(end.diff(start));
      return Math.round(duration.asDays());
    },
    // retrieveCasefiles() {
    //   CasefileDataService.getAll()
    //     .then((response) => {
    //       this.casefiles = response.data;
    //       this.loadTable = false;
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },

    onUpdateOptions(options) {
      if (!options) return;
      const page = options.page || 1;
      const itemsPerPage = options.itemsPerPage || 50;
      this.page = page;
      this.pageSize = itemsPerPage;
      this.retrieveCasefiles(page, itemsPerPage);
    },

    // Vuetify emits these for pagination changes depending on version
    onPageChange(page) {
      this.page = page || 1;
      this.retrieveCasefiles(this.page, this.pageSize);
    },
    onItemsPerPageChange(itemsPerPage) {
      this.pageSize = itemsPerPage || 50;
      this.page = 1;
      this.retrieveCasefiles(this.page, this.pageSize);
    },

    async retrieveCasefiles(page = 1, limit = 50) {
      this.loadTable = true;
      try {
        const user = this.$store.state.auth.user || {};
        const fileStatus = this.$route.params.fileStatus;
        const rawBranch = this.$route.params.branch;

        // Normalize branch parameter to numeric id. If caller passed a branch code/string, try to resolve it.
        let branch = Number(rawBranch);
        if (Number.isNaN(branch)) {
          // Try to find in locally cached branches first
          let found = this.branches.find(
            (b) => String(b.brCode) === String(rawBranch) || String(b.name) === String(rawBranch)
          );
          if (!found) {
            // fetch branches and try again
            try {
              const resp = await BranchDataService.getAll();
              this.branches = resp.data || this.branches;
              found = this.branches.find(
                (b) => String(b.brCode) === String(rawBranch) || String(b.name) === String(rawBranch)
              );
            } catch (be) {
              // unable to resolve branch id; continue with rawBranch
            }
          }
            if (found) {
             branch = found.id;
           } else {
            // leave branch as raw string if unresolved; backend may handle or fallback will be used
            branch = rawBranch;
          }
        }

        // Prefer the generic paginated endpoint which centralizes filter & role logic
        let resp = null;
        try {
          resp = await CasefileDataService.getPaginated({ page, pageSize: limit, fileStatus, branch, needCount: true, roles: user.roles, dept: user.dept, branches: user.branches, userId: user.id });
        } catch (e) {
          // fallback to dedicated status+branch endpoint
          resp = await CasefileDataService.getPaginatedByStatusBranch(fileStatus, branch, { page, limit, needCount: true, roles: user.roles, dept: user.dept, branches: user.branches, userId: user.id });
        }

        // Normalize response
        const payload = resp && resp.data !== undefined ? resp.data : resp;
        if (payload && Array.isArray(payload.data)) {
          this.casefiles = payload.data;
          // Coerce total whether number or numeric string
          const tot = payload.total != null ? Number(payload.total) : NaN;
          this.total = Number.isFinite(tot) && tot > 0 ? tot : payload.data.length;
        } else if (payload && Array.isArray(payload.rows) && typeof payload.count !== 'undefined') {
          // Support direct Sequelize findAndCountAll shape: { count, rows }
          this.casefiles = payload.rows;
          const tot = Number(payload.count);
          this.total = Number.isFinite(tot) && tot > 0 ? tot : payload.rows.length;
        } else if (Array.isArray(payload)) {
          this.casefiles = payload;
          this.total = payload.length;
        } else if (payload && payload.data) {
          this.casefiles = payload.data;
          const tot = payload.total != null ? Number(payload.total) : NaN;
          this.total = Number.isFinite(tot) && tot > 0 ? tot : (Array.isArray(payload.data) ? payload.data.length : 0);
        } else {
          this.casefiles = payload || [];
          this.total = Array.isArray(this.casefiles) ? this.casefiles.length : 0;
        }

        // If server didn't provide a reliable total (or it's equal to the page length), fetch accurate count grouped by fileStatus
            try {
              if (this.total <= (Array.isArray(this.casefiles) ? this.casefiles.length : 0)) {
                const countsResp = await CasefileDataService.getCountsBy('fileStatus', { branch, fileStatus });
                if (countsResp && countsResp.data && countsResp.data.counts) {
                  const cnt = countsResp.data.counts[fileStatus];
                  if (typeof cnt === 'number') this.total = cnt;
                }
              }
            } catch (ce) {
              // ignore - counts are best-effort
            }
       } catch (e) {
        console.error("Error fetching casefiles:", e);
        // fallback to old detail endpoint
        try {
          const fallback = await CasefileDataService.getAllStatusBranch(this.$route.params.fileStatus, this.$route.params.branch);
          this.casefiles = fallback.data || [];
          this.total = Array.isArray(this.casefiles) ? this.casefiles.length : 0;
        } catch (e2) {
          console.error("Fallback fetch also failed:", e2);
        }
      } finally {
        this.loadTable = false;
      }
    },

    retrieveDepts() {
      DeptDataService.getAll()
        .then((response) => {
          this.departments = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    retrieveSubRefType() {
      SubRefTypeDataService.getAll()
        .then((response) => {
          this.subRefTypes = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    retrieveBranches() {
      BranchDataService.getAll()
        .then((response) => {
          this.branches = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    retrieveStates() {
      StateDataService.getAll()
        .then((response) => {
          this.states = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    retrieveIns() {
      InsDataService.getAll()
        .then((response) => {
          this.insurer = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    retrieveMembers() {
      MemberDataService.getAll()
        .then((response) => {
          this.members = response.data.filter((item) =>
            item.roles.some((b) => b.roleCode === "adjuster")
          );
        })
        .catch((e) => {
          console.error(e);
        });
    },
    retrieveStages() {
      StagesDataService.getAll()
        .then((response) => {
          this.stages = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    viewItem(id) {
      this.$router.push({
        name: "vuexFile",
        params: { id: id.id },
      });
    },
  },
};
</script>
